import { combineReducers } from 'redux';
import update from './update';
import * as fromUpdate from './update';
import fetch from './fetch';
import * as fromFetch from './fetch';

export default combineReducers({
  update,
  fetch,
});

export const getUpdatingUser = (state) => fromUpdate.getUser(state.update);

export const isUpdatingUser = (state) => fromUpdate.isUpdating(state.update);

export const getUsers = (state) => fromFetch.getUsers(state.fetch);

export const isFetchingUsers = (state) => fromFetch.isFetching(state.fetch);
